import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      usuario: '',
      loading_suscripciones: false,
      suscripciones: [],
      columnas_suscripciones: [
        { text: "Suscripción", value: 'tipo_suscripcion.nombre' },
        { text: "Descripción", value: 'tipo_suscripcion.descripcion' },
        { text: "Fecha Inicio", value: 'fecha_inicio' },
        { text: "Fecha Fin", value: 'fecha_fin' },
        { text: "Ver declaraciones", value: 'accion' },
      ],
      dialogeDeclaraciones: false,
      anios: [],
      anio_seleccionado: 0,
      loading_anio: false,
      loading_screen: false,
      declaraciones: [],
      columnas_declaraciones: [
        { text: 'Mes', value: 'mes' },
        { text: 'Fecha en que se presentó', value: 'fecha_declaracion' },
        { text: 'Sumatoria de facturas Q', value: 'total_fatura', align: 'end' },
        { text: 'Sumatoria de retenciones Q', value: 'total_retencion', align: 'end' },
        { text: 'Impuesto Pagado Q', value: 'pago', align: 'end' },
        { text: 'Estado de la declaración', value: 'status' },
        { text: 'Acciones', value: 'accion', sortable: false, align: 'end' }
      ]
    };
  },
  async created() {
    console.log(' estado_declaracion.created');
    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      //Casteo de información a estring
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      //Casteo de JSON String a Object json
      let r = JSON.parse(informacion_desincriptada)
      this.usuario = r.usuario[0]
      let anio = new Date(Date.now()).getFullYear() - 3;
      this.anios.push(anio);
      for (let i = 0; i < 6; i++) {
        this.anios.push(anio + (i + 1));
      }
      await this.obtenerSuscripcionesUsuario(this.usuario.id);
    }

  },
  methods: {

    async descargarBoleta(item) {
      console.log('descargarBoleta', item);
      this.loading_screen = true;


      try {

        let fecha = item.fecha_presentacion;

        let mes = fecha.split('-')[1];
        let anio = fecha.split('-')[2];

        let usuario_id = this.usuario.id;
        let body = {
          usuario: usuario_id,
          mes_transaccion: mes,
          anio_transaccion: anio
        };

        let r = await this.$store.state.services.reportesService.buscarDocumentosSat(body);
        console.log('r', r);
        // este responde un array de pdfs debes buscar esta propiedad base64
        if (r.data.data.length > 0 && typeof(r.data.data) !== 'string') {
          for (let i = 0; i < r.data.data.length; i++) {
            setTimeout(() => {
              let base64 = r.data.data[i].base64;
              let nombre = r.data.data[i].file_name;
              let link = document.createElement('a');
              link.href = `data:application/pdf;base64,${base64}`;
              link.download = nombre;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }, i* 1000); 
          }


          console.log('Documentos descargados correctamente');
          this.$toast.success('Documentos descargados correctamente', {
            timeout: 3000,
            position: 'top-right'
          });
        } else {
          this.$toast.info('No se encontraron documentos para descargar', {
            timeout: 3000,
            position: 'top-right'
          });
        }


      } catch (error) {

        console.log(error, 'error al descargar la boleta');
      } finally {
        this.loading_screen = false;
      }
    },

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },

    async obtenerSuscripcionesUsuario(id) {
      console.log('obtenerSuscripcionesUsuario');
      try {
        this.loading_suscripciones = true;
        let r = await this.$store.state.services.usuarioService.obtenerSuscripcionesUsuario(id);
        r.data.data.filter(x => x.loading = false);
        this.suscripciones = r.data.data;
        this.loading_suscripciones = false;
      } catch (error) {
        this.loading_suscripciones = false;
        console.log(error, 'error al obtener el tipo de suscripciones');
      }
    },
    async obtenerDetallePresentaciones(item) {
      console.log('obtenerDetallePresentaciones');
      try {
        item.loading = true;
        let r = await this.$store.state.services.usuarioService.obtenerDetallePresentaciones(item.id);
        this.dialogeDeclaraciones = true;
        this.declaraciones = r.data.data;
        item.loading = false;
      } catch (error) {
        item.loading = false;
        console.log(error, 'error al ver el detalle de las declaraciones');
      }
    },
    async obtenerDetallePresentacionesAño() {
      console.log('obtenerDetallePresentacionesAño');
      let usuario = this.usuario.id;
      try {
        this.loading_anio = true;
        let r = await this.$store.state.services.usuarioService.obtenerDetallePresentacionCompleta(usuario, this.anio_seleccionado);
        this.dialogeDeclaraciones = true;
        this.declaraciones = r.data.data;
        this.loading_anio = false;
        this.anio_seleccionado = '';
        console.log(r);
      } catch (error) {
        this.loading_anio = false;
        console.log(error, 'error al ver el detalle de las declaraciones');
      }
    }
  },
  async mounted() {
    console.log("/estado_declaracion");
  },
}